/**
 * Page not found route
 */
import React from "react"
import { ThemeProvider } from "styled-components"
import theme from "styles/theme-main"
import { Row, TextWrapper } from "./styles"
import { Wrapper } from "styles/Common"
import LayoutContainer from "components/LayoutContainer"
import Text from "components/Text"
import PageTitle from "components/PageTitle"

export class NotFound extends React.Component {
  render() {
    return (
      <ThemeProvider theme={theme}>
        <LayoutContainer>
          <Wrapper>
            <PageTitle label="PAGE NOT FOUND" />
            <Row>
              <TextWrapper>
                <Text as={"div"}>
                  We're sorry, but we couldn't find the page you're looking for.
                </Text>
              </TextWrapper>
            </Row>
          </Wrapper>
        </LayoutContainer>
      </ThemeProvider>
    )
  }
}

export default NotFound
